import React from 'react';

import './index.scss';

//material ui
import CircularProgress from '@material-ui/core/CircularProgress';

//api
import { api } from '../../functions/api';

//custom componetns
import CustomTabs from '../../components/basic/customTabs';
import BasicInfo from './basic';
import ContactInfo from './contact';
import SeoInfo from './seo';

//other libraries
import { toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import Monitoring from './monitoring'

@inject('internal')
@inject('translate')
@observer
export default class Settings extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            openSnackbar: false,
            message: "",
        }
    }

    tabsConfig = [
        {
            label: this.props.translate.i18n.MODULES.SETTINGS.BASIC_INFO,
            url: "/settings/basic"
        },
        {
            label: this.props.translate.i18n.MODULES.SETTINGS.CONTACT,
            url: "/settings/contact"
        },
        {
            label: this.props.translate.i18n.MODULES.SETTINGS.SEO,
            url: "/settings/seo"
        },
        {
            label: this.props.translate.i18n.MODULES.SETTINGS.MONITORING,
            url: "/settings/monitoring"
        },
        // {
        //     label: this.props.translate.i18n.MODULES.SETTINGS.BEKOSHOP,
        //     url: "/settings/bekoshop"
        // },
    ]

    componentDidMount() {
        this.props.internal.setRoute(this.props.history, this.props.location.pathname);
        if(toJS(this.props.internal.user)
            && toJS(this.props.internal.user.data)
            && toJS(this.props.internal.user.data.permissions)
            && toJS(this.props.internal.user.data.permissions.global_settings)
            && toJS(this.props.internal.user.data.permissions.global_settings.view)){

            this.loadGlobalSettigns();
            this.props.internal.setHeaderTitle(this.props.translate.i18n.MODULES.SETTINGS.HEADER_TITLE)
        }
        else {
            this.props.internal.setRoute(this.props.history, this.props.location.pathname)
            this.props.internal.pushRoute('/')
            this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.NOT_PERMISSIONS, true)
        }
    }

    loadGlobalSettigns = async() => {

        let load_global_settings = await api({
            method:'get',
            url:'global-settings',
            authorization: this.props.internal.user.access_token,
        })

        if(load_global_settings.success === true) {
            this.props.internal.setDataForSimpeTable(load_global_settings.data.data);
        }
        this.setState({loading: false})
    }

    render() {
        const routerData = {
            history: this.props.history,
            location: this.props.location,
            match: this.props.match
        }
        return (
            this.state.loading ?
                <CircularProgress className={'circular-progress'}/>
                :
                <div className={'global-setings'}>
                    <CustomTabs
                        tabsConfig={this.tabsConfig }
                        routerData={routerData}
                        module={'/settings'}
                        goBackNone
                        >
                            {this.state.loading ? null :
                                <BasicInfo routerData={routerData}></BasicInfo>
                            }
                            {this.state.loading ? null :
                                <ContactInfo routerData={routerData}></ContactInfo>
                            }
                            {this.state.loading ? null :
                                <SeoInfo routerData={routerData}></SeoInfo>
                            }
                            {this.state.loading ? null :
                                <Monitoring routerData={routerData}/>
                            }
                            {/* {this.state.loading ? null :
                                <BekoShop routerData={routerData}></BekoShop>
                            } */}
                            
                        </CustomTabs>
                </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/settings/index.js